"use client";

import { useRef, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AnimatedText from "../common/AnimatedText";

export default function CareersForm() {
  const form = useRef();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");
  const [subject, setSubject] = useState("");

  const validate = (data) => {
    const newErrors = {};
    if (!data.name?.trim()) {
      newErrors.name = "Name is required";
    } else if (data.name.trim().length < 3) {
      newErrors.name = "Name must be at least 3 characters";
    } else if (data.name.trim().length > 50) {
      newErrors.name = "Name cannot exceed 50 characters";
    }

    if (!data.email?.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
      newErrors.email = "Invalid email format";
    }

    const pureNumber = data.number?.replace(/\D/g, "") || "";
    if (!pureNumber) {
      newErrors.number = "Phone number is required";
    } else if (pureNumber.length !== 10) {
      newErrors.number = "Phone number must be exactly 10 digits";
    }

    if (!data.subject?.trim()) {
      newErrors.subject = "Applied Position is required";
    } else if (data.subject.trim().length < 3) {
      newErrors.subject = "Position must be at least 3 characters";
    } else if (data.subject.trim().length > 55) {
      newErrors.subject = "Position cannot exceed 55 characters";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});

    const formData = new FormData(form.current);
    const data = Object.fromEntries(formData.entries());

    const validationErrors = validate(data);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setLoading(false);
      toast.error("Please fill in all required fields correctly.", {
        position: "bottom-right",
      });
      return;
    }

    try {
      // Save to database
      const dbRes = await fetch("/api/careers/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!dbRes.ok) {
        throw new Error("Failed to save to database");
      }

      toast.success("Application Submitted successfully!", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      form.current.reset();
      setMessage("");
      setSubject("");
    } catch (error) {
      console.error(error);
      toast.error("Error submitting application", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="contact-section-22">
      <div className="container1">
        <div className="contact-form-items">
          <div className="title text-center">
            <h2 className="splt-txt wow">
              <AnimatedText text="Join Our Team" />
            </h2>
            <h3 className="wow fadeInUp ">
              <span className="text-[#0993de] font-bold">
                <AnimatedText text="Hiring" />
                <br></br>
                <span className="text-lg text-black ">
                  <AnimatedText text="careers@arenawaterpark.com
" />
                </span>
              </span>
            </h3>



          </div>
          <form ref={form} onSubmit={handleSubmit} noValidate>
            <div className="row g-4">
              <div className="col-lg-12 wow fadeInUp" data-wow-delay=".2s">
                <div className="form-clt">
                  <input
                    type="text"
                    name="name"
                    id="name"
                    maxLength={50}
                    placeholder="Your Name"
                    className={errors.name ? "border-danger" : ""}
                  />
                  <div className="icon">
                    <i className="fa-regular fa-user" />
                  </div>
                  {errors.name && (
                    <span className="text-danger small mt-1">
                      {errors.name}
                    </span>
                  )}
                </div>
              </div>
              <div className="col-lg-12 wow fadeInUp" data-wow-delay=".4s">
                <div className="form-clt">
                  <input
                    type="email"
                    name="email"
                    id="email"
                    maxLength={90}
                    placeholder="Email Address"
                    className={errors.email ? "border-danger" : ""}
                  />
                  <div className="icon">
                    <i className="fa-regular fa-envelope" />
                  </div>
                  {errors.email && (
                    <span className="text-danger small mt-1">
                      {errors.email}
                    </span>
                  )}
                </div>
              </div>

              <div className="col-lg-12 wow fadeInUp" data-wow-delay=".2s">
                <div className="form-clt">
                  <input
                    type="tel"
                    name="number"
                    id="number"
                    placeholder="Phone Number"
                    inputMode="numeric"
                    maxLength={10}
                    className={`border p-2 rounded w-full ${errors.number ? "border-red-500" : "border-gray-300"
                      }`}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      e.target.value = value;
                    }}
                  />

                  <div className="icon">
                    <i className="fa-regular fa-phone" />
                  </div>
                  {errors.number && (
                    <span className="text-danger small mt-1">
                      {errors.number}
                    </span>
                  )}
                </div>
              </div>

              <div className="col-lg-12 wow fadeInUp" data-wow-delay=".4s">
                <div className="form-clt">
                  <input
                    type="text"
                    name="subject"
                    id="subject"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    maxLength={55}
                    placeholder="What Job Looking For"
                    className={errors.subject ? "border-danger" : ""}
                  />
                  <div className="flex justify-end pr-2">
                    <span className="text-sm text-gray-500">
                      {subject.length} / {55}
                    </span>
                  </div>

                  <div className="icon">
                    <i className="fa-regular fa-tag" />
                  </div>
                  {errors.subject && (
                    <span className="text-danger small mt-1">
                      {errors.subject}
                    </span>
                  )}
                </div>
              </div>
              <div className="col-lg-12 wow fadeInUp" data-wow-delay=".4s">
                <button
                  type="submit"
                  className="theme-btn w-100"
                  disabled={loading}
                >
                  {loading ? "SENDING..." : "Apply Now"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
